import React from "react";
import ConfirmDeleteDialog from "../../common/ConfirmDeleteDialog";

interface DeleteLogoModalProps {
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
    title?: string;
    confirmText?: string;
    description?: string;
}

const DeleteLogoModal: React.FC<DeleteLogoModalProps> = ({
    open,
    onClose,
    onDelete,
    title = "Delete Logo",
    confirmText = "Are you sure you want to delete this logo?",
    description = "This action cannot be undone.",
}) => {
    return (
        <ConfirmDeleteDialog
            open={open}
            onClose={onClose}
            onDelete={onDelete}
            title={title}
            confirmText={confirmText}
            description={description}
        />
    );
};

export default DeleteLogoModal;
